<div>
  <div *ngFor="let chat of messages" class="chat-container">
    <div class="chat-message user-message">
      <div class="message-content">
        <p>{{ chat.request }}</p>
        <span class="message-time">{{
          chat.requestDate | date: "h:mm a, EEEE d MMMM y"
        }}</span>
      </div>
    </div>

    <div class="chat-message ai-message">
      <div class="profile-photo">
        <img src="/assets/images/ncc-logo.svg" alt="AI Photo" />
      </div>
      <div class="message-content">
        <div
          *ngIf="!chat.response?.length"
          class="chat-loader pulse-animation"
        ></div>
        <p>
          {{ chat.response }}
        </p>
        <span class="message-time">{{
          chat.responseDate | date: "h:mm a, EEEE d MMMM y"
        }}</span>
        <div *ngIf="chat.response?.length" class="references-wrapper">
          <p class="show-references" (click)="handleReference(chat)">
            {{
              showReference && activeChat.id === chat.id
                ? "hide reference"
                : "show reference"
            }}
          </p>
          <div
            class="references"
            
            *ngIf="showReference && activeChat.id === chat.id"
          >
            <h4>References</h4>
            <ul *ngFor="let ref of chat.references">
              <h5>{{ref.title}}</h5>
              <a target="_blank" [href]="ref.reference">{{ref.reference}}</a>
            </ul>
          </div>
        </div>
        <div *ngIf="chat.response?.length" class="actions">
          <button
            *ngIf="!chat.negativeFeedBack"
            (click)="
              chat.positiveFeedBack ? null : giveFeedback('POSITIVE', chat)
            "
            [ngClass]="{ inactive: chat.positiveFeedBack }"
          >
            <img
              *ngIf="!chat.positiveFeedBack && feedbackType != 'POSITIVE'"
              src="/assets/icons/like.svg"
            />
            <img
              *ngIf="
                !chat.positiveFeedBack &&
                feedbackType == 'POSITIVE' &&
                chat.id != activeChat.id
              "
              src="/assets/icons/like.svg"
            />
            <img
              *ngIf="
                chat.positiveFeedBack ||
                (feedbackType == 'POSITIVE' && chat.id === activeChat.id)
              "
              src="/assets/icons/reg-like.svg"
            />
          </button>

          <button
            *ngIf="!chat.positiveFeedBack"
            (click)="
              chat.negativeFeedback ? null : giveFeedback('NEGATIVE', chat)
            "
            [ngClass]="{ inactive: chat.negativeFeedBack }"
          >
            <img
              *ngIf="!chat.negativeFeedBack && feedbackType != 'NEGATIVE'"
              src="/assets/icons/dislike.svg"
            />
            <img
              *ngIf="
                !chat.negativeFeedBack &&
                feedbackType == 'NEGATIVE' &&
                chat.id != activeChat.id
              "
              src="/assets/icons/dislike.svg"
            />
            <img
              *ngIf="
                chat.negativeFeedBack ||
                (feedbackType == 'NEGATIVE' && chat.id === activeChat.id)
              "
              src="/assets/icons/reg-dislike.svg"
            />
          </button>
        </div>
        <form
          class="feedback-form"
          [formGroup]="feedbackForm"
          (ngSubmit)="ngSubmit()"
          *ngIf="isGivingFeedback && chat.id === activeChat.id"
        >
          <textarea
            type="text"
            class="form-control"
            [placeholder]="
              feedbackType == 'POSITIVE'
                ? 'What did you like?'
                : 'What can we improve?'
            "
            formControlName="feedback"
          ></textarea>
          <div class="bottom">
            <button
              type="submit"
              class="ui primary button"
              [disabled]="!(canReply$ | async)"
            >
              Submit
            </button>
            <button
              type="button"
              class="ui red button"
              (click)="cancelFeedback()"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
